"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createRef = _interopRequireDefault(require("./createRef"));

var _RefForwarder2 = _interopRequireDefault(require("./RefForwarder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _react.default.forwardRef || function forwardRef(render) {
  return (
    /*#__PURE__*/
    function (_RefForwarder) {
      _inheritsLoose(_class2, _RefForwarder);

      function _class2() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _RefForwarder.call.apply(_RefForwarder, [this].concat(args)) || this;

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "__render", render);

        return _this;
      }

      return _class2;
    }(_RefForwarder2.default)
  );
};

exports.default = _default;